"use strict";

// Workspace thread: history paging and live activity (W4a).
//
// Division of labour with communication.js, which still owns this surface's
// composer, mentions, attachments and live MESSAGE appends:
//
//   server render  -> the initial thread, messages and activity interleaved
//   this file      -> "load earlier" (thread.json) and live activity:event
//   communication  -> composing, and live message:event
//
// The split exists because the message renderer predates activity events and
// knows nothing about them; teaching it both shapes would have meant rewriting
// a working composer to add a feature beside it.

(function () {
  var stream = document.getElementById('chatStream');
  if (!stream) return;

  var chat = document.querySelector('.chat');
  if (!chat || chat.getAttribute('data-thread-mode') !== 'workspace') return;

  var threadUrl = chat.getAttribute('data-thread-url');
  var channelId = chat.getAttribute('data-channel-id');
  var moreBtn = document.getElementById('threadMore');

  // Seed from what the server rendered so a live event that races the page
  // load cannot insert a duplicate.
  var seen = Object.create(null);
  Array.prototype.forEach.call(stream.querySelectorAll('[data-entry-id]'), function (li) {
    seen[li.getAttribute('data-entry-kind') + ':' + li.getAttribute('data-entry-id')] = true;
  });

  function esc(t) { return String(t == null ? '' : t); }

  function renderActivity(e) {
    var li = document.createElement('li');
    li.className = 'chat__entry chat__entry--activity';
    li.setAttribute('data-entry-id', e.id);
    li.setAttribute('data-entry-kind', 'activity');

    var dot = document.createElement('span');
    dot.className = 'chat__activity-dot';
    dot.setAttribute('aria-hidden', 'true');

    var body = document.createElement('span');
    body.className = 'chat__activity-body';

    var actor = document.createElement('span');
    actor.className = 'chat__activity-actor';
    actor.textContent = (e.actor && e.actor.label) || 'System';

    var label = document.createElement('span');
    label.className = 'chat__activity-label';
    label.textContent = esc(e.label || e.body);   // textContent, never innerHTML

    body.appendChild(actor);
    body.appendChild(document.createTextNode(' '));
    body.appendChild(label);

    var time = document.createElement('time');
    time.className = 'chat__activity-time';
    time.setAttribute('datetime', e.created_on);
    time.textContent = e.created_on;

    li.appendChild(dot);
    li.appendChild(body);
    li.appendChild(time);
    return li;
  }

  function atBottom() {
    return (stream.scrollHeight - stream.scrollTop - stream.clientHeight) < 80;
  }

  // Live activity. Newest at the bottom, matching the thread's direction.
  window.addEventListener('rushworks:activity-event', function (ev) {
    var e = ev.detail;
    if (!e) return;
    var key = 'activity:' + e.id;
    if (seen[key]) return;
    seen[key] = true;

    var empty = stream.querySelector('.chat__empty');
    if (empty) empty.remove();

    var stick = atBottom();
    stream.appendChild(renderActivity(e));
    if (stick) stream.scrollTop = stream.scrollHeight;
  });

  // "Load earlier" prepends the previous page, preserving scroll position so
  // the reader does not lose their place when content is inserted above.
  if (moreBtn && threadUrl) {
    moreBtn.addEventListener('click', function () {
      var before = stream.getAttribute('data-next-before');
      if (!before) return;
      moreBtn.disabled = true;

      var url = threadUrl + '?channel=' + encodeURIComponent(channelId)
              + '&before=' + encodeURIComponent(before);

      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (page) {
          var beforeHeight = stream.scrollHeight;
          var anchor = moreBtn.parentNode;   // the <li> holding the button

          (page.entries || []).forEach(function (e) {
            var key = e.entry + ':' + e.id;
            if (seen[key]) return;
            seen[key] = true;
            if (e.entry === 'activity') {
              stream.insertBefore(renderActivity(e), anchor.nextSibling);
            } else {
              var li = document.createElement('li');
              li.className = 'chat__entry chat__entry--message';
              li.setAttribute('data-entry-id', e.id);
              li.setAttribute('data-entry-kind', 'message');
              var head = document.createElement('div');
              head.className = 'chat__msg-head';
              var who = document.createElement('span');
              who.className = 'chat__msg-author actor-' + ((e.actor && e.actor.kind) || 'system');
              who.textContent = (e.actor && e.actor.label) || 'Someone';
              head.appendChild(who);
              var t = document.createElement('time');
              t.className = 'chat__msg-time';
              t.setAttribute('datetime', e.created_on);
              t.textContent = e.created_on;
              head.appendChild(t);
              var b = document.createElement('div');
              b.className = 'chat__msg-body';
              b.textContent = esc(e.body);
              li.appendChild(head);
              li.appendChild(b);
              stream.insertBefore(li, anchor.nextSibling);
            }
          });

          if (page.next_before) {
            stream.setAttribute('data-next-before', page.next_before);
            moreBtn.disabled = false;
          } else {
            anchor.remove();
            stream.removeAttribute('data-next-before');
          }
          // Keep the reader's place: content was inserted above them.
          stream.scrollTop += (stream.scrollHeight - beforeHeight);
        })
        .catch(function () { moreBtn.disabled = false; });
    });
  }

  // Open at the newest entry, which is the bottom.
  stream.scrollTop = stream.scrollHeight;
})();
